import { useCallback, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { UserDiscount } from '../types/user-discount.type';
import { USER_DISCOUNTS_API_PATHS } from '../constants/users-paths.constants';

interface GetUserDiscountsResponse {
  data: {
    discounts: UserDiscount[];
  };
}

type UseGetUserDiscountsResult = {
  isLoadingDiscounts: boolean;
  discounts: UserDiscount[];
  refreshDiscounts: () => Promise<void>;
};

export function useGetUserDiscounts(userId: string): UseGetUserDiscountsResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoadingDiscounts, setIsLoadingDiscounts] = useState(true);
  const [discounts, setDiscounts] = useState<UserDiscount[]>([]);

  const refreshDiscounts = useCallback(async () => {
    setIsLoadingDiscounts(true);
    try {
      const response = await HttpClient.get<GetUserDiscountsResponse>(
        USER_DISCOUNTS_API_PATHS.GET_USER_DISCOUNTS(userId)
      );
      setDiscounts(response.data.discounts);
    } catch (error) {
      enqueueSnackbar(extractTranslatedApiErrorMessage(error, "Erreur lors de la récupération des bons d'achat"), {
        variant: 'error',
      });
    } finally {
      setIsLoadingDiscounts(false);
    }
  }, [userId, enqueueSnackbar]);

  useEffect(() => {
    refreshDiscounts();
  }, [refreshDiscounts]);

  return { isLoadingDiscounts, discounts, refreshDiscounts };
}
